import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SwotMatrix from './SwotMatrix';
import SwotHeader from './SwotHeader';
import SwotControls from './SwotControls';
import ExportModal from './ExportModal';
import ImportModal from './ImportModal';

const SwotDashboard = () => {
  const [showExportModal, setShowExportModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);

  return (
    <div className="min-h-screen p-4 md:p-6 lg:p-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-7xl mx-auto"
      >
        <SwotHeader />
        
        <SwotControls 
          onExport={() => setShowExportModal(true)}
          onImport={() => setShowImportModal(true)}
        />
        
        <SwotMatrix />
        
        {showExportModal && (
          <ExportModal onClose={() => setShowExportModal(false)} />
        )}
        
        {showImportModal && (
          <ImportModal onClose={() => setShowImportModal(false)} />
        )}
      </motion.div>
    </div>
  );
};

export default SwotDashboard;